import { render, staticRenderFns } from "./BillingDetail.vue?vue&type=template&id=935aefe6&"
import script from "./BillingDetail.vue?vue&type=script&lang=js&"
export * from "./BillingDetail.vue?vue&type=script&lang=js&"
import style0 from "./BillingDetail.vue?vue&type=style&index=0&id=935aefe6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports